import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  row: {
    mb: '24px'
  } satisfies SxProps<Theme>,
  tile: {
    p: '16px 20px',
    flex: 1,
    minWidth: 150,
    borderRadius: '10px'
  } satisfies SxProps<Theme>,
  value: (color: string) => ({
    color,
    fontWeight: 800,
    lineHeight: 1
  } satisfies SxProps<Theme>),
  label: {
    color: 'text.secondary',
    mt: '6px'
  } satisfies SxProps<Theme>,
  compactRow: {
    backgroundColor: 'var(--grey-50)',
    px: '16px',
    py: '14px'
  } satisfies SxProps<Theme>,
  compactTile: {
    p: '10px 14px',
    flex: 1,
    minWidth: 130,
    borderRadius: '8px'
  } satisfies SxProps<Theme>,
  compactValue: (color: string) => ({
    color,
    fontWeight: 800,
    fontSize: '20px',
    lineHeight: 1
  } satisfies SxProps<Theme>),
  compactLabel: {
    color: 'text.secondary'
  } satisfies SxProps<Theme>
}
